const PRIVATE_PROJECT_DETAIL_SEGMENTS = new Set(["object", "material", "asset", "history", "debug"]);

function locationToPathname(location) {
  if (typeof location === "string") {
    return location;
  }

  return location?.pathname || "/";
}

function normalizePathname(location) {
  const rawPathname = locationToPathname(location).split("?")[0].split("#")[0].trim();
  const pathname = rawPathname.startsWith("/") ? rawPathname : `/${rawPathname}`;
  const withoutTrailingSlash = pathname.replace(/\/+$/, "");

  return withoutTrailingSlash || "/";
}

function normalizeBasePath(basePath) {
  const normalized = String(basePath || "")
    .trim()
    .replace(/\/+$/, "");
  return normalized && normalized !== "/" ? normalized : "";
}

function stripCreatorBasePath(pathname, basePath) {
  const normalizedBasePath = normalizeBasePath(basePath);

  if (!normalizedBasePath) {
    return pathname;
  }

  if (pathname === normalizedBasePath) {
    return "/";
  }

  return pathname.startsWith(`${normalizedBasePath}/`) ? pathname.slice(normalizedBasePath.length) : pathname;
}

function buildProjectPagePath(basePath) {
  const normalizedBasePath = normalizeBasePath(basePath);
  return `${normalizedBasePath}/projects/:projectId`;
}

export function classifyGlobalJourneyRoute(location, basePath = "") {
  const normalizedPathname = normalizePathname(location);
  const routePathname = stripCreatorBasePath(normalizedPathname, basePath);

  if (routePathname.split("/").some(segment => segment.toLowerCase().includes("callback"))) {
    return {
      shouldTrack: false,
      reason: "auth_callback"
    };
  }

  const projectMatch = routePathname.match(/^\/projects\/([^/]+)(?:\/(.*))?$/);
  if (projectMatch) {
    const detailPath = projectMatch[2] || "";
    const detailSegment = detailPath.split("/")[0];

    if (PRIVATE_PROJECT_DETAIL_SEGMENTS.has(detailSegment)) {
      return {
        shouldTrack: false,
        reason: "private_detail"
      };
    }

    if (!detailPath) {
      return {
        shouldTrack: true,
        pageView: {
          pagePath: buildProjectPagePath(basePath),
          pageTitle: "XR Creator Project",
          pageType: "xr_creator_project",
          appArea: "xr_creator"
        }
      };
    }
  }

  return {
    shouldTrack: false,
    reason: "not_allowlisted"
  };
}
